// Buffer shim
export const Buffer = {
    isBuffer: () => false,
};
